import React from "react";
import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import Login from "../auth/login";
import Register from "../auth/register";
import StepFirst from "../auth/register-steps/stepFirst";
import StepSecond from "../auth/register-steps/stepSecond";
import ThankYou from "../auth/register-steps/thankYou";
import VerificationOtp from "../auth/verification-otp";
import ForgotPassword from "../auth/forgot-password";
import ResetPassword from "../auth/reset-password";

import Pricing from "../pages/pricing";
import PaymentSuccess from "../pages/payment-success";
import PaymentFailed from "../pages/payment-failed";
import Dashboard from "../dashboard/page";
import Profile from "../pages/profile/page";

import ManageUser from "../pages/manage-user";
import AddMember from "../pages/manage-user/add-member";
import Properties from "../pages/properties";
import LogHours from "../pages/log-hours";
import LogHoursRequests from "../pages/log-hours/requests";
import LogHoursAdd from "../pages/log-hours/add";
import Mileage from "../pages/mileage";
import AddMileage from "../pages/mileage/add";

import ComingSoon from "../pages/coming-soon";
import ContactUs from "../cmsPages/contact-us/contact-us";
import Error404 from "../pages/error-404";

import Maintenance from "../pages/maintenance";
import VerifyAccountPage from "../auth/verify-account";
import ConfirmEmail from "../auth/confirm-email";
import SuccessMessage from "../auth/success-message";
import EmailPassword from "../auth/email-password";
import ProfileChangePassword from "../pages/profile/profile-change-password";
import AddProperties from "../pages/properties/add";
import HelpCenter from "../pages/help-center";
import UserSetPassword from "../auth/user-set-password";
import AcceptInvitation from "../auth/accept-invitation";
import LogHoursDetail from "../pages/log-hours/detail";
import Reports from "../pages/reports";
import GeneratedReports from "../pages/reports/generated-reports";
import BillingAndSubscription from "../pages/billing-and-subscription";
import Notifications from "../pages/notifications";
import Activity from "../nonRealEstate/activity";
import LogEntry from "../nonRealEstate/log-entry";
import NonrealestateReports from "../nonRealEstate/reports";
import NonRealReports from "../nonRealEstate/reports";
import NonRealaddmember from "../nonRealEstate/manage-user/add-member";
import NonRealmember from "../nonRealEstate/manage-user";
import NonRealdashboard from "../nonRealEstate/dashboard";
import AuditTrail from "../pages/audit-trail";

import SpouseDashboard from "../spouse/dashboard";
import SpouseProperties from "../spouse/properties";
import SpousePropertiesDetail from "../spouse/properties/property-detail";
import SpouseMileage from "../spouse/mileage";
import AddSpouseMileage from "../spouse/mileage/add";
import SpouseLogHours from "../spouse/log-hours";
import SpouseLogHoursAdd from "../spouse/log-hours/add";
import SpouseLogHoursDetail from "../spouse/log-hours/detail";
import SpouseReports from "../spouse/reports";

import CpaDashboard from "../taxProfessional/dashboard";
import CpaProperties from "../taxProfessional/properties";
import CpaPropertiesDetail from "../taxProfessional/properties/property-detail";
import CpaLogHours from "../taxProfessional/log-hours";
import CpaLogHoursDetail from "../taxProfessional/log-hours/detail";
import CpaMileage from "../taxProfessional/mileage";

import Chatbot from "../../core/components/chat-bot";
import CpaAuditTrail from "../taxProfessional/audit-trail";
import CpaReports from "../taxProfessional/reports";
import NonRealBillingAndSubscription from "../nonRealEstate/billing-and-subscription";
import CpaGeneratedReports from "../taxProfessional/reports/generated-reports";
import SpouseGeneratedReports from "../spouse/reports/generated-reports";
import NonRealGeneratedReports from "../nonRealEstate/reports/generated-reports";
import PlanList from "../../core/components/billingAndSubscriptionTabs/PlanList";
import AboutUs from "../cmsPages/about-us/about-us";
import Faq from "../cmsPages/faq/faq";
import Blog from "../cmsPages/blog/blog";
import SinglePost from "../cmsPages/blog/details";
import TermsCondition from "../cmsPages/terms-conditions/terms-conditions";
import PrivacyPolicy from "../cmsPages/privacy-policy/privacy-policy";
import CmsPricing from "../cmsPages/pricing/pricing";
import CustomerSupport from "../pages/customer-support/page";

const routes = all_routes;

//  CMS pages – public, no token required
const cmsPages = [
  { path: all_routes.aboutUs, element: <AboutUs />, route: Route },
  { path: all_routes.blog, element: <Blog />, route: Route },
  { path: all_routes.blogDetails, element: <SinglePost />, route: Route },
  { path: all_routes.faq, element: <Faq />, route: Route },
  { path: all_routes.cmsPricing, element: <CmsPricing />, route: Route },
  { path: all_routes.contactUs, element: <ContactUs />, route: Route },
  {
    path: all_routes.termsCondition,
    element: <TermsCondition />,
    route: Route,
  },
  { path: all_routes.privacyPolicy, element: <PrivacyPolicy />, route: Route },
  // { path: routes.pricing, element: <Pricing />, route: Route },
];

//  Auth-only pages – always under AuthLayout
const authRoutes = [
  { index: true, element: <Navigate to={routes.login} replace /> },
  { path: routes.login, element: <Login />, route: Route },
  { path: routes.register, element: <Register />, route: Route },
  { path: routes.verificationOtp, element: <VerificationOtp />, route: Route },
  { path: routes.successMessage, element: <SuccessMessage />, route: Route },
  { path: routes.thankYou, element: <ThankYou />, route: Route },
  { path: routes.forgotPasssword, element: <ForgotPassword />, route: Route },
  { path: routes.resetPassword, element: <ResetPassword />, route: Route },

  {
    path: routes.acceptInvitation,
    element: <AcceptInvitation />,
    route: Route,
  },

  { path: routes.pricing, element: <Pricing />, route: Route },
  { path: routes.paymentSuccess, element: <PaymentSuccess />, route: Route },
  { path: routes.PaymentFailed, element: <PaymentFailed />, route: Route },

  { path: routes.emailPassword, element: <EmailPassword />, route: Route },
  { path: routes.userSetPassword, element: <UserSetPassword />, route: Route },
  { path: routes.confirmEmail, element: <ConfirmEmail />, route: Route },
];

//  Protected pages – need token + main header
const protectedPages = [
  // Owner RealEstate pages
  {
    path: routes.dashboard,
    element: <Dashboard />,
    route: Route,
  },
  {
    path: routes.profile,
    element: <Profile />,
    route: Route,
  },
  {
    path: routes.profileChangePassword,
    element: <ProfileChangePassword />,
    route: Route,
  },
  {
    path: routes.manageUser,
    element: <ManageUser />,
    route: Route,
  },
  {
    path: routes.addMember,
    element: <AddMember />,
    route: Route,
  },
  {
    path: routes.properties,
    element: <Properties />,
    route: Route,
  },
  {
    path: routes.addProperties,
    element: <AddProperties />,
    route: Route,
  },
  {
    path: routes.editProperties,
    element: <AddProperties />,
    route: Route,
  },
  {
    path: routes.logHours,
    element: <LogHours />,
    route: Route,
  },
  {
    path: routes.logHoursRequests,
    element: <LogHoursRequests />,
    route: Route,
  },
  {
    path: routes.addLogHours,
    element: <LogHoursAdd />,
    route: Route,
  },
  {
    path: routes.editLogHours,
    element: <LogHoursAdd />,
    route: Route,
  },
  {
    path: routes.logHoursDetails,
    element: <LogHoursDetail />,
    route: Route,
  },
  {
    path: routes.mileage,
    element: <Mileage />,
    route: Route,
  },
  {
    path: routes.addMileage,
    element: <AddMileage />,
    route: Route,
  },
  {
    path: routes.editMileage,
    element: <AddMileage />,
    route: Route,
  },
  {
    path: routes.auditTrail,
    element: <AuditTrail />,
    route: Route,
  },
  {
    path: routes.reports,
    element: <Reports />,
    route: Route,
  },
  {
    path: routes.generatedReports,
    element: <GeneratedReports />,
    rute: Route,
  },
  {
    path: routes.billingAndSubscription,
    element: <BillingAndSubscription />,
    route: Route,
  },
  {
    path: routes.planList,
    element: <PlanList />,
    route: Route,
  },


  {
    path: "*",
    name: "NotFound",
    element: <Navigate to="/index" />,
    route: Route,
  },

  // Spouse pages
  {
    path: routes.spouseDashboard,
    element: <SpouseDashboard />,
    route: Route,
  },
  {
    path: routes.spouseProperties,
    element: <SpouseProperties />,
    route: Route,
  },
  {
    path: routes.spousePropertiesDetail,
    element: <SpousePropertiesDetail />,
    route: Route,
  },
  {
    path: routes.spouseMileage,
    element: <SpouseMileage />,
    route: Route,
  },
  {
    path: routes.addSpouseMileage,
    element: <AddSpouseMileage />,
    route: Route,
  },
  {
    path: routes.editSpouseMileage,
    element: <AddSpouseMileage />,
    route: Route,
  },
  {
    path: routes.spouseLogHours,
    element: <SpouseLogHours />,
    route: Route,
  },
  {
    path: routes.addSpouseLogHours,
    element: <SpouseLogHoursAdd />,
    route: Route,
  },
  {
    path: routes.editSpouseLogHours,
    element: <SpouseLogHoursAdd />,
    route: Route,
  },
  {
    path: routes.spouseLogHoursDetails,
    element: <SpouseLogHoursDetail />,
    route: Route,
  },
  {
    path: routes.spouseReports,
    element: <SpouseReports />,
    route: Route,
  },
  {
    path: routes.spouseGeneratedReports,
    element: <SpouseGeneratedReports />,
    route: Route,
  },

  // tax professional Pages
  {
    path: routes.cpaDashboard,
    element: <CpaDashboard />,
    route: Route,
  },
  {
    path: routes.cpaProperties,
    element: <CpaProperties />,
    route: Route,
  },
  {
    path: routes.cpaPropertiesDetail,
    element: <CpaPropertiesDetail />,
    route: Route,
  },
  {
    path: routes.cpaLogHours,
    element: <CpaLogHours />,
    route: Route,
  },
  {
    path: routes.cpaLogHoursDetails,
    element: <CpaLogHoursDetail />,
    route: Route,
  },
  {
    path: routes.cpaMileage,
    element: <CpaMileage />,
    route: Route,
  },
  {
    path: routes.cpaAuditTrail,
    element: <CpaAuditTrail />,
    route: Route,
  },
  {
    path: routes.cpaReports,
    element: <CpaReports />,
    route: Route,
  },
  {
    path: routes.cpaGeneratedReports,
    element: <CpaGeneratedReports />,
    route: Route,
  },

  // Non RealEstate pages
  {
    path: routes.nonRealDashboard,
    element: <NonRealdashboard />,
    route: Route,
  },
  {
    path: routes.nonRealActivity,
    element: <Activity />,
    route: Route,
  },
  {
    path: routes.nonRealLogHours,
    element: <LogEntry />,
    route: Route,
  },
  {
    path: routes.nonRealReports,
    element: <NonRealReports />,
    route: Route,
  },
  {
    path: routes.nonRealGeneratedReports,
    element: <NonRealGeneratedReports />,
    route: Route,
  },
  {
    path: routes.nonRealManageUser,
    element: <NonRealmember />,
    route: Route,
  },
  {
    path: routes.nonRealBillingAndSubscription,
    element: <NonRealBillingAndSubscription />,
    route: Route,
  },

  {
    path: routes.NonRealaddmember,
    element: <NonRealaddmember />,
    route: Route,
  },

  // Spouse pages
  {
    path: routes.spouseDashboard,
    element: <SpouseDashboard />,
    route: Route,
  },

  // Common pages
  {
    path: routes.chatbot,
    element: <Chatbot />,
    route: Route,
  },
  {
    path: routes.helpCenter,
    element: <HelpCenter />,
    route: Route,
  },
  {
    path: routes.notifications,
    element: <Notifications />,
    route: Route,
  },
  {
    path: routes.customerSupport,
    element: <CustomerSupport />,
    route: Route,
  },
];

//  Bare pages – no header/footer at all
const barePages = [
  {
    path: routes.comingSoon,
    element: <ComingSoon />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.verifyAccount,
    element: <VerifyAccountPage />,
    route: Route,
  },
  {
    path: routes.maintenance,
    element: <Maintenance />,
    route: Route,
  },
  // Register steps Routes
  {
    path: routes.stepOne,
    element: <StepFirst />,
    route: Route,
  },
  {
    path: routes.stepTwo,
    element: <StepSecond />,
    route: Route,
  },
];

export { cmsPages, authRoutes, protectedPages, barePages };
